import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { BASE_URL } from '../config/api'; // Assuming BASE_URL is correctly defined

const EditPromotion = () => {
    const [promotion, setPromotion] = useState({
        description: '',
        type: 'Flat', // Default value, update as per your requirements
        from_period: '',
        to_period: '',
        happy_hour_from: '',
        happy_hour_to: '',
        discount_on: '',
        discount_rate: '',
        skip_location: '',
    });
    const { id } = useParams(); // Get promotion ID from URL
    const navigate = useNavigate();

    // Fetch promotion details by ID
    useEffect(() => {
        fetch(`${BASE_URL}promotions/${id}`)
            .then(response => response.json())
            .then(data => {
                if (data.status === 'success') {
                    setPromotion(data.data); // Pre-fill the form with promotion data
                }
            })
            .catch(error => console.error('Error fetching promotion:', error));
    }, [id]);

    // Handle form field changes
    const handleChange = (e) => {
        const { name, value } = e.target;
        setPromotion({ ...promotion, [name]: value });
    };

    // Submit the form to update promotion
    const handleSubmit = (e) => {
        e.preventDefault();

        fetch(`${BASE_URL}promotions/${id}`, {
            method: 'PUT',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(promotion),
        })
            .then(response => response.json())
            .then(data => {
                if (data.status === 'success') {
                    alert('Promotion updated successfully!');
                    navigate('/PromotionsList'); // Navigate to the promotion list after successful update
                } else {
                    alert('Failed to update promotion.');
                }
            })
            .catch(error => {
                console.error('Error updating promotion:', error);
                alert('Failed to update promotion.');
            });
    };

    return (
        <div id="main">
            <header className="mb-3">
                <a href="#" className="burger-btn d-block d-xl-none">
                    <i className="bi bi-justify fs-3"></i>
                </a>
            </header>

            <div className="page-heading">
                <h3>Edit Promotion</h3>
            </div>

            <section className="section">
                <div className="row">
                    <div className="col-12 col-md-6 offset-md-3">
                        <div className="card">
                            <div className="card-header">
                                <h4>Edit Promotion</h4>
                            </div>
                            <div className="card-body">
                                <form onSubmit={handleSubmit}>
                                    <div className="form-group">
                                        <label>Description</label>
                                        <input
                                            type="text"
                                            name="description"
                                            className="form-control"
                                            value={promotion.description}
                                            onChange={handleChange}
                                            required
                                        />
                                    </div>
                                    <div className="form-group">
                                        <label>Discount Rate (%)</label>
                                        <input
                                            type="number"
                                            name="discount_rate"
                                            className="form-control"
                                            value={promotion.discount_rate}
                                            onChange={handleChange}
                                            required
                                        />
                                    </div>
                                    <div className="form-group">
                                        <label>From Period</label>
                                        <input
                                            type="date"
                                            name="from_period"
                                            className="form-control"
                                            value={promotion.from_period}
                                            onChange={handleChange}
                                            required
                                        />
                                    </div>
                                    <div className="form-group">
                                        <label>To Period</label>
                                        <input
                                            type="date"
                                            name="to_period"
                                            className="form-control"
                                            value={promotion.to_period}
                                            onChange={handleChange}
                                            required
                                        />
                                    </div>
                                    <div className="form-group">
                                        <label>Happy Hour From</label>
                                        <input
                                            type="time"
                                            name="happy_hour_from"
                                            className="form-control"
                                            value={promotion.happy_hour_from}
                                            onChange={handleChange}
                                            required
                                        />
                                    </div>
                                    <div className="form-group">
                                        <label>Happy Hour To</label>
                                        <input
                                            type="time"
                                            name="happy_hour_to"
                                            className="form-control"
                                            value={promotion.happy_hour_to}
                                            onChange={handleChange}
                                            required
                                        />
                                    </div>
                                    <div className="form-group">
                                        <label>Discount On</label>
                                        <input
                                            type="text"
                                            name="discount_on"
                                            className="form-control"
                                            value={promotion.discount_on}
                                            onChange={handleChange}
                                            required
                                        />
                                    </div>
                                    <div className="form-group">
                                        <label>Skip Location</label>
                                        <input
                                            type="text"
                                            name="skip_location"
                                            className="form-control"
                                            value={promotion.skip_location}
                                            onChange={handleChange}
                                            required
                                        />
                                    </div>
                                    <button type="submit" className="btn btn-primary mt-3">
                                        Save Changes
                                    </button>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default EditPromotion;
